import { z } from 'zod';
import { socketLogger } from '@/core/utils/logger';

// --- Server -> Client payload schemas ---

export const messageCreatedPayloadSchema = z.object({
  conversationId: z.string().min(1),
  message: z.object({
    id: z.string().min(1),
    conversationId: z.string().min(1),
    content: z.string(),
    messageType: z.string(),
    status: z.string(),
    sentAt: z.unknown(),
  }).passthrough(),
}).passthrough();

export const messageStatusUpdatePayloadSchema = z.object({
  conversationId: z.string().min(1),
  messageIds: z.array(z.string()),
  status: z.string(),
  userId: z.string(),
  timestamp: z.unknown(),
}).passthrough();

// --- Helper ---

export function parseServerEvent<T extends z.ZodType>(
  schema: T,
  data: unknown,
  eventName: string,
): { data: z.infer<T>; valid: true } | { data: unknown; valid: false } {
  const result = schema.safeParse(data);
  if (!result.success) {
    socketLogger.warn(`[WebSocket] Invalid payload for ${eventName}`, {
      errors: result.error.issues,
      receivedKeys: data && typeof data === 'object' ? Object.keys(data) : [],
    });
    return { data, valid: false };
  }
  return { data: result.data, valid: true };
}
